import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {GridList} from 'shells/grid-list/grid-list';

import type {MeetingStubFragment} from 'nutshell-graphql-types';

import {MeetingReviewCard} from './meeting-review-card/meeting-review-card';

type Props = {
    meetings: MeetingStubFragment[] | null | undefined;
    activeFilters: FilterObject[];
    isLoading: boolean;
    error: string | null | undefined;
    isFiltering: boolean;
    emptyStateComponent: React.ReactNode;
};

export function MeetingsBoardView(props: Props) {
    return (
        <GridList
            customFillRule='repeat(auto-fill, minmax(490px, 1fr))'
            isLoading={props.isLoading}
            loadingState={{itemBackgroundColor: 'white'}}
            isFiltering={props.isFiltering}
            error={props.error}
            nothingFoundState={{title: 'No meetings were found'}}
            emptyStateComponent={props.emptyStateComponent}
        >
            {props.meetings
                ? props.meetings.map((meeting) => (
                      <MeetingReviewCard
                          key={meeting.id}
                          meeting={meeting}
                          activeFilters={props.activeFilters}
                      />
                  ))
                : null}
        </GridList>
    );
}
